import { HTTP } from "@/axios"
import { AUTOMATIC_MESSAGE } from "../helpers/helpers"
import { Alert } from 'element-ui';

const dayjs = require('dayjs')


export const isLoading =  ({ commit } ) => {
    commit('isLoading')
    return { ok: true };
}

export const iniciarCasoAutWcx =  ({ commit } ) => {
    commit('iniciarCasoAutWcx')
    return { ok: true };
}

export const loadDatos =  ({ commit }, { pedido } ) => {

   
            getDataVtex({commit},{pedido})
        
}

export const selectedProduct =  ({ commit }, { products } ) => {
    commit('selectedProduct', products)
    return { ok: true };
}

export const getDataVtex = ({ commit }, { pedido } ) => { 
    let dataVtex = {}
     //agregar el localstorage
    HTTP.post("/getDataVtex", { pedido })
        .then((res) => {
          if (res.data.status) {
            
            let vtex = JSON.parse(res.data.data);
            console.log('vuex getDataVtex res', vtex);

            dataVtex.items              = vtex.items
            dataVtex.totals             = vtex.totals
            dataVtex.changesAttachment  = vtex.changesAttachment
            dataVtex.packageAttachment  = vtex.packageAttachment
            dataVtex.paymentData        = vtex.paymentData.transactions
            dataVtex.statusDescription  = vtex.statusDescription
            dataVtex.allowCancellation  = vtex.allowCancellation
            dataVtex.allowEdition       = vtex.allowEdition
            dataVtex.cancelReason       = vtex.cancelReason
            dataVtex.cancellationData   = vtex.cancellationData
            dataVtex.logisticsInfo      = ( vtex.shippingData.logisticsInfo && vtex.shippingData.logisticsInfo.length ) ? vtex.shippingData.logisticsInfo[0] : []
            dataVtex.remove             = vtex.changesAttachment ? vtex.changesAttachment.changesData.map((cd) =>  cd.itemsRemoved)
                                                                            .reduce((prev, next) => prev.concat(next)) : [];

            for (let i = 0; i < vtex.items.length; i++) {
              for (let index = 0; index < dataVtex.remove.length; index++) {
                if (
                  parseInt(dataVtex.remove[index].id) === parseInt(vtex.items[i].id)
                ) {
                  vtex.items[i].modificado = 1;
                  vtex.items[i].cambios = dataVtex.remove[index];
                  if (vtex.items[i].quantity - dataVtex.remove[index].quantity) {
                    vtex.items[i].orden = -99;
                  } else {
                    vtex.items[i].orden = -100;
                  }
                }
              }
              if (!vtex.items[i].modificado) {
                vtex.items[i].modificado = 0;
                vtex.items[i].cambios = {};
                vtex.items[i].orden = 1;
              }
            }
            window.localStorage.setItem(pedido, JSON.stringify(dataVtex))
            commit('dataVtex', dataVtex)
            let fechaEstimada, fechaCreacion
    
            fechaEstimada = vtex.shippingData.logisticsInfo[0].shippingEstimateDate
            fechaCreacion = vtex.creationDate
            
            if ([0, 6].includes(dayjs(fechaEstimada).day())) {
              fechaEstimada = dayjs(fechaEstimada).add(1, 'day')
               calcularPlazoEntrega({ commit }, { fechaCreacion: fechaCreacion, fechaEstimada: fechaEstimada })
              isLoading({commit})
            }
            else{
               calcularPlazoEntrega({ commit }, { fechaCreacion: fechaCreacion, fechaEstimada: fechaEstimada })
            isLoading({commit})
            }

           
          }
        })
        .catch( (err) => { console.log(err) })
    return { ok: true };
}

export const calcularPlazoEntrega = ({commit}, { fechaCreacion, fechaEstimada } ) => {

  const diferencia   = dayjs(fechaEstimada).diff(new Date(fechaCreacion), "day")
  const enTiempo     = dayjs(fechaEstimada).isAfter(new Date())
  let fechaEntrega   = fechaEstimada
  // if ([0,6].includes(dayjs(fechaEstimada).day()))
  //  {
  //  fechaEntrega = fechaEstimada
  //  }
  //  else {
  //   fechaEntrega = dayjs(fechaEstimada).add(1,'day')
  //  }
 

  const enFarmaciaHasta = dayjs(new Date(fechaEstimada).setDate( new Date(fechaEstimada).getDate() + 30 )).format('DD/MM/YYYY')
  // const dias30 =  dayjs(enFarmaciaHasta).isAfter(new Date())

  
  commit('fechaEntrega', fechaEntrega  )
  commit('plazoEntrega', diferencia)
  commit('enTiempo', enTiempo)
  commit('enFarmaciaHasta', enFarmaciaHasta )
  // commit('dias30', dias30 )





}

export const iniciarReclamoLocal = async ( { commit }, { id, motivo_id, productos} ) => {

  return HTTP.post("/setReclamo", {
      vtex_id : id,
      motivo  : motivo_id,
      articulos: productos
  })
  .then( ({ data }) => {

    commit('reclamo', data )
    console.log('vuex seReclamo data', data);
    return data
    
  })
  .catch( ( err ) => {
    console.log('err - vuex setReclamo', err);
  })
  
}



export const guardarMensaje = ({commit}, { content, reclamo }) => {
  console.log('vuex - guardar mensaje:', content, reclamo)
  HTTP.post('/guardarMensaje', { mensaje: content, reclamo: reclamo })
        .then( (res) => {
          console.log('mensaje guardado?', res)
      }) 
        .catch( (err) => {
          console.log('error catch:', err)
      })
}
export const procesarReclamo = ({commit}, { datosWc, motivoIngresado, productos }) => {

  const enEspera = [2,9,6,8,14,21,19,10]
  return HTTP.post("/procesarReclamo", {
    vtex_id       : datosWc.vtex_id,
    motivo        : datosWc.motivo_id,
    envio     : datosWc.envio,
    articulos     : productos,
    message       : datosWc,
    motivo_nombre : motivoIngresado.motivo ? motivoIngresado.motivo.toUpperCase() : '',
})
.then( ({data}) => {


  return { ok: true , reclamo: data};
})
.catch( (err) => {
  // commit('closeLoading', false)
  return false;
  
})

}
export const cancelarPedido = ({commit}, { datosWc, motivoIngresado, productos }) => {
  // commit('isLoading')
  console.log('cancelarPedido datosWc', datosWc);
  return HTTP.post("/cancelarPedido", {
    vtex_id       : datosWc.vtex_id,
    motivo        : datosWc.motivo_id,
    articulos     : productos,
    message       : datosWc,
    envio     : datosWc.envio,
    motivo_nombre : motivoIngresado.motivo.toUpperCase(),
    motivo_cliente: motivoIngresado.causa ? motivoIngresado.causa.replace(/[^a-z0-9áéíóúñü \\.,_-]/gim, "") : ''
})
.then( ({data}) => {
  console.log('datda',data);
  // commit('reclamo', data.reclamo)
  commit('setNumeroCaso', data.webcentrix.number_case)
  commit('setArrepentido', true)

  return { ok: true, reclamo: data };
})
.catch( (err) => {
  return false;
})

}
export const cancelarPedidoOld = async ( { commit }, { message } ) => {
  // let message = {}
  console.log('datos a enviar - vuex cp', message);
  commit('ocultarChat', false)
  commit('setArrepentido', true)
  // return await iniciarReclamoLocal({ commit }, { id, motivo_id})
  // await iniciarReclamoLocal({ commit }, { id, motivo_id})
  console.log(commit);
  // setTimeout(() => {
    return HTTP.post("/setMensaje", message )
      .then( ({data}) => {
        
        console.log('vuex setMensaje',data)
        commit('setNumeroCaso', data.number_case)      
       
        return data.number_case
      })
      .catch( (err) => {
        console.log(err);
      })
  // }, 500);

}
export const crearCasoWebCentrix = ({commit}, { datosWc, motivoIngresado, productos }) => {


  procesarReclamo({ commit }, { datosWc, motivoIngresado, productos })
                      .then( (res) => {
                        console.log('crearCasoWebCentrix', res);
                        
                      })
                      .catch( () => {
                          //! enviar el caso nuevamente
                      })
        
}

export const addMensaje = ({ commit }, { mensaje }) => {
  if (mensaje && mensaje.content.length) {
    commit('addMessage', mensaje)
  }
}



export const getNumeroCaso = ({commit}, {idwc}) => {
  HTTP.post("/getNumeroCaso", idwc)
        .then((res) => console.log('numero de caso wc', res))
}

export const verificarCasoLocalWC = ({commit}, {vtex_id}) => {
  console.log('vuex vtex_id', vtex_id);
  return HTTP.post("/verificarCasoLocal", {vtex_id})
          .then(({data}) =>  data )
}
